<div class="source-node" [style.--depth]="depth">
  <button type="button" class="node-row" [class.selected]="selected" (click)="toggle()">
    <i
      class="fa-solid node-chevron"
      [ngClass]="{
        'fa-chevron-right': node.children?.length && !expanded,
        'fa-chevron-down': node.children?.length && expanded,
        'fa-circle': !node.children?.length
      }"
    ></i>
    <span class="node-kind">{{ node.kind }}</span>
    <span class="node-label">{{ node.label || node.name }}</span>
    <span class="node-value" *ngIf="!node.children?.length">{{ node.value ?? node.raw }}</span>
  </button>

  <div class="node-children" *ngIf="expanded">
    <lib-edi-source-tree-node
      *ngFor="let child of node.children"
      [node]="child"
      [depth]="depth + 1"
      [expandedNodeIds]="expandedNodeIds"
      [selectedNodeIds]="selectedNodeIds"
      [scrollTargetId]="scrollTargetId"
      (sourceSelected)="sourceSelected.emit($event)"
    ></lib-edi-source-tree-node>
  </div>
</div>
